"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearch = void 0;
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const SearchService_1 = require("src/contexts/SearchService");
const CHUNK_SIZE = 100;
const useSearch = (mintAddresses, options = {}) => {
    var _a, _b;
    const mintAddressesString = (0, react_1.useMemo)(() => mintAddresses.join(','), [mintAddresses]);
    return (0, react_query_1.useQuery)({
        queryKey: ['search', mintAddressesString],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            if (mintAddresses.length === 0) {
                return SearchService_1.searchService.search('');
            }
            // Split into chunks of 100
            const chunks = [];
            for (let i = 0; i < mintAddresses.length; i += CHUNK_SIZE) {
                chunks.push(mintAddresses.slice(i, i + CHUNK_SIZE));
            }
            // Make requests for each chunk
            const chunkPromises = chunks.map(chunk => SearchService_1.searchService.search(chunk.join(',')));
            // Wait for all requests to complete
            const results = yield Promise.allSettled(chunkPromises);
            return results.flatMap(result => result.status === 'fulfilled' ? result.value : []);
        }),
        enabled: (_a = options.enabled) !== null && _a !== void 0 ? _a : true,
        staleTime: (_b = options.staleTime) !== null && _b !== void 0 ? _b : Infinity,
    });
};
exports.useSearch = useSearch;
